<template>
	<div v-if="item.price_custom > 0 && (item.loyalty_price_custom || installmentPrice)">
		<template v-if="isLoyalty == true && item.loyalty_price_custom"></template>
		<template v-else>
			<template v-if="item.installments_calculation && item.installments_calculation.loyalty && !item.loyalty_price_custom">
				<template v-if="isLoggedIn && isLoyalty == true"></template>
				<template v-else>
					<div class="cd-loyalty-price-container">
						<div class="cd-loyalty-price" v-html="labels.get('loyalty_price_installments').replace('%PRICE%', loyaltyMinPrice)"></div>
						<div @click="flyoutLoyalty" class="cd-loyalty-price-button btn cd-flyout-btn">
							<span><BaseCmsLabel code="loyalty_join_button" /></span>
						</div>
					</div>
				</template>
			</template>
			<template v-else-if="item.loyalty_price_custom">
				<div class="cd-loyalty-price-container">
					<template v-if="item.type == 'advanced'">
						<div v-if="item.primary_product_data && !advancedItem" class="cd-current-price"><BaseUtilsFormatCurrency :price="item.price_custom" /></div>
						<template v-if="item.type_config">
							<div v-for="(config, key) in item.type_config" :key="key">
								<template v-if="advancedItem && advancedItem == key">
									<div class="cd-loyalty-price" v-if="config?.price_custom > 0 && config?.loyalty_price_custom < config?.basic_price_custom">
										<BaseCmsLabel code="loyalty_user_price" tag="span" />
										<BaseUtilsFormatCurrency :price="item.loyalty_price_custom" />
									</div>
								</template>
							</div>
						</template>
					</template>
					<template v-else>
						<div class="cd-loyalty-price">
							<BaseCmsLabel code="loyalty_user_price" tag="span" />
							<BaseUtilsFormatCurrency :price="item.loyalty_price_custom" />
						</div>
					</template>
					<div @click="flyoutLoyalty" class="cd-loyalty-price-button btn cd-flyout-btn"><BaseCmsLabel code="loyalty_join_button" tag="span" /></div>
				</div>
			</template>
			<template v-else-if="item.installments_calculation?.loyalty && isLoyalty == false">
				<div class="cd-loyalty-price-container">
					<div class="cd-loyalty-price" v-html="labels.get('loyalty_price_installments').replace('%PRICE%', loyaltyMinPrice)"></div>
					<div @click="flyoutLoyalty" class="cd-loyalty-price-button btn cd-flyout-btn"><BaseCmsLabel code="loyalty_join_button" tag="span" /></div>
				</div>
			</template>
		</template>
	</div>
</template>

<script setup>
	const labels = useLabels();
	const auth = useAuth();
	const props = defineProps(['item', 'advancedItem']);
	const {formatDate} = useText();
	const {formatCurrency} = useCurrency();
	const {emit} = useEventBus();
	const isLoggedIn = computed(() => auth.isLoggedIn());

	//loyalty
	const isLoyalty = computed(() => {
		const user = auth.getUser();
		if(user?.loyalty_code) {
			return true;
		} else {
			return false;
		}
	});

	let loyaltyMinPrice = computed(() => {
		if (props.item.installments_calculation && props.item.installments_calculation.loyalty && Object.keys(props.item.installments_calculation.loyalty).length > 0) {
			const values = Object.values(props.item.installments_calculation.loyalty);
			const minValue = Math.min(...values);
			return minValue;
		} else {
			return false;
		}
	});

	function flyoutLoyalty() {
		document.body.classList.add('flyout-page', 'cd-flyout-active');

		const flyoutLoyaltyTitle = isLoggedIn.value ? labels.get('loyalty_flyout_title') : labels.get('loyalty_not_user_flyout_title');
		const flyoutLoyaltyMode = isLoggedIn.value ? 'loyaltyLoggedIn' : 'loyaltyNotLoggedIn';
		emit('flyoutUpdate', {'flyout_mode': flyoutLoyaltyMode, 'flyout_title': flyoutLoyaltyTitle});
	}

	//installments
	const installmentPrice = computed(() => {
		if (props.item?.installments_calculation && props.item?.installments_calculation?.regular) {
			const values = Object.values(props.item.installments_calculation.regular);
			return Math.min(...values);
		}
		if(isLoyalty.value == true && props.item?.installments_calculation && props.item?.installments_calculation?.loyalty) {
			const values = Object.values(props.item.installments_calculation.loyalty);
			return Math.min(...values);
		}
	});
</script>

<style lang="less" scoped>
	.cd-loyalty-price-container{
		display: flex; align-items: center; width: 100%; margin: 0 0 15px; padding: 12px 0; border-top: 1px solid @borderColor; border-bottom: 1px solid @borderColor; position: relative;

		@media (max-width: @m){width: calc(~"100% - -30px"); margin: 0 0 10px -15px; padding: 13px 15px;}
	}
	.cd-loyalty-price{
		flex-grow: 1; padding-right: 20px; font-size: 28px; line-height: 1.2; font-weight: 600; color: @blue;
		span{display: block; font-size: 13px; padding-bottom: 1px;}

		@media (max-width: @t){
			font-size: 26px;
			span{font-size: 13px;}
		}
	}
	.cd-loyalty-price-button{
		height: 44px; padding: 0 30px; font-size: 15px; cursor: pointer;
		span{
			padding-right: 18px; position: relative;
			&:before{.icon-arrow(); font: 10px/10px @fonti; color: @white; font-weight: 600; position: absolute; top: 5px; right: 0; z-index: 1; .rotate(180deg);}
		}
	}
</style>
